// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"LayoutView_layoutWrapper__MC9yx","scrollToTop":"LayoutView_scrollToTop__eYuP9"};